import { stringValidator } from '#validation/common/validators';
import { SERVICE_ACCOUNT_NAME_CONTENT_REGEX, SERVICE_ACCOUNT_NAME_END_REGEX, SERVICE_ACCOUNT_NAME_MAX_LENGTH, SERVICE_ACCOUNT_NAME_OPENAPI_REGEX, SERVICE_ACCOUNT_NAME_START_REGEX, } from '../constants';
export const serviceAccountNameValidator = stringValidator({
    requiredError: 'serviceAccount.name.required',
    maxLength: {
        max: SERVICE_ACCOUNT_NAME_MAX_LENGTH,
        error: 'serviceAccount.name.maxLength',
    },
    formats: [
        {
            regex: SERVICE_ACCOUNT_NAME_START_REGEX,
            error: 'serviceAccount.name.startChar',
        },
        {
            regex: SERVICE_ACCOUNT_NAME_END_REGEX,
            error: 'serviceAccount.name.endChar',
        },
        {
            regex: SERVICE_ACCOUNT_NAME_CONTENT_REGEX,
            error: 'serviceAccount.name.invalidChar',
        },
    ],
    openApiFormat: SERVICE_ACCOUNT_NAME_OPENAPI_REGEX,
}).refine((val) => val.trim().length > 0, {
    message: 'serviceAccount.name.required',
});
